<iframe [src]="tramlineassist" width="100%" height="100%" title="ROW CROP ASSIST">